export const CHECKOUT = '/checkout';
export const PAYMENT = '/payment';
